var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setup-page"},[_c('SetupWizard',{on:{"setup-completed":_vm.onSetupCompleted,"setup-failed":_vm.onSetupFailed},model:{value:(_vm.showWizard),callback:function ($$v) {_vm.showWizard=$$v},expression:"showWizard"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }